import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.reports');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;
declare let WizRoute: any;

@Component({
    standalone: false,
    selector: 'wiz-page-reports',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.reports/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageReportsComponent implements OnInit, OnDestroy {
    @ViewChild('momentReportChart') momentReportChart?: ElementRef<HTMLCanvasElement>;
    @ViewChild('forceReportChart') forceReportChart?: ElementRef<HTMLCanvasElement>;
    @ViewChild('currentComparisonChart') currentComparisonChart?: ElementRef<HTMLCanvasElement>;
    @ViewChild('speedComparisonChart') speedComparisonChart?: ElementRef<HTMLCanvasElement>;
    @ViewChild('mcuTimeOverlayChart') mcuTimeOverlayChart?: ElementRef<HTMLCanvasElement>;

    public reports: any[] = [];
    public selectedReport: any = null;
    public reportTypes: string[] = ['설계 타당성', '시뮬레이션 결과', '디지털 트윈 검증', 'MCU 비교 검증', 'AI 설계 종합', '부하 분석', '온도 영향'];
    public isGenerating: boolean = false;
    private charts: Chart[] = [];
    private routerSub: any = null;

    // MCU 시계열 비교 (FN-0004)
    public mcuTimeData: any = null;
    public isLoadingMcuTime: boolean = false;
    public mcuTimeTab: string = 'moment';

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {}

    public async ngOnInit() {
        await this.service.init();
        await this.loadReports();
        await this.syncRouteSelection();
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                await this.syncRouteSelection();
                await this.service.render();
            }
        });
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        this.destroyCharts();
    }

    public async loadReports() {
        const { code, data } = await wiz.call("list");
        if (code === 200) {
            this.reports = data;
        }
    }

    public selectReport(report: any) {
        if (!report?.id) return;
        this.service.href(`/reports/${report.id}`);
    }

    public backToList() {
        this.destroyCharts();
        this.selectedReport = null;
        this.service.href('/reports');
    }

    public async generateReport() {
        this.isGenerating = true;
        await this.service.render();
        const { code, data } = await wiz.call("generate");
        if (code === 200) {
            await this.loadReports();
        }
        this.isGenerating = false;
        await this.service.render();
    }

    public async deleteReport(report: any, event?: Event) {
        if (event) event.stopPropagation();
        if (!report?.id) return;

        const ok = await this.service.modal.show({
            title: '리포트 삭제',
            message: `'${report.title || '선택한 리포트'}' 리포트를 삭제하시겠습니까?`,
            action: '삭제',
            cancel: '취소',
            status: 'error'
        });
        if (!ok) return;

        const { code, data } = await wiz.call("delete", { id: report.id });
        if (code !== 200) {
            await this.service.modal.show({
                title: '삭제 실패',
                message: data?.message || '리포트를 삭제하지 못했습니다.',
                action: '확인',
                cancel: false,
                status: 'error'
            });
            return;
        }

        await this.loadReports();
        if (this.selectedReport?.id === report.id) {
            this.destroyCharts();
            this.selectedReport = null;
            this.service.href('/reports');
            return;
        }
        await this.service.render();
    }

    private currentReportId(): string {
        return WizRoute?.segment?.id || '';
    }

    private async syncRouteSelection() {
        const reportId = this.currentReportId();
        if (!reportId) {
            if (this.selectedReport) {
                this.destroyCharts();
                this.selectedReport = null;
            }
            return;
        }

        if (this.selectedReport?.id === reportId) {
            return;
        }

        const { code, data } = await wiz.call("detail", { id: reportId });
        if (code !== 200) {
            this.destroyCharts();
            this.selectedReport = null;
            this.service.href('/reports');
            return;
        }

        this.selectedReport = data;
        await this.service.render();
        this.renderChartsSoon();
    }

    public getTypeBadgeClass(type: string): string {
        const colors: any = {
            '설계 타당성': 'bg-blue-100 text-blue-700',
            '시뮬레이션 결과': 'bg-emerald-100 text-emerald-700',
            '디지털 트윈 검증': 'bg-cyan-100 text-cyan-700',
            'MCU 비교 검증': 'bg-cyan-100 text-cyan-700',
            'AI 설계 종합': 'bg-violet-100 text-violet-700',
            '부하 분석': 'bg-amber-100 text-amber-700',
            '온도 영향': 'bg-red-100 text-red-700',
            'AI 추천 종합': 'bg-violet-100 text-violet-700',
        };
        return colors[type] || 'bg-gray-100 text-gray-700';
    }

    public async exportReport(format: string) {
        if (!this.selectedReport?.id) {
            this.service.modal.show({
                title: '내보내기',
                message: '리포트를 먼저 선택해주세요.',
                action: '확인',
                cancel: false
            });
            return;
        }
        const map: any = { 'PDF': 'pdf', 'Excel': 'xlsx', 'CSV': 'csv', 'JSON': 'json', 'Share': 'json' };
        const fmt = map[format] || format.toLowerCase();
        const id = this.selectedReport.id;
        const url = `/wiz/api/page.reports/export?id=${encodeURIComponent(id)}&format=${fmt}`;
        const a = document.createElement('a');
        a.href = url;
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    public hasRows(rows: any): boolean {
        return Array.isArray(rows) && rows.length > 0;
    }

    public hasMomentChartData(): boolean {
        return this.hasRows(this.selectedReport?.momentData || this.selectedReport?.moment_analysis);
    }

    public hasForceChartData(): boolean {
        return this.hasRows(this.selectedReport?.forceData || this.selectedReport?.force_analysis);
    }

    public isMcuComparisonReport(): boolean {
        return this.selectedReport?.mode === 'mcu_comparison'
            || this.selectedReport?.mode === 'digital_twin_validation'
            || this.selectedReport?.type === 'MCU 비교 검증'
            || this.selectedReport?.type === '디지털 트윈 검증';
    }

    public isCaseReport(): boolean {
        return this.selectedReport?.mode === 'case_report' || this.selectedReport?.type === 'AI 설계 종합';
    }

    public briefEntries(): any[] {
        const labels: any = {
            vehicle: '차종', partType: '가동부', hingeType: '힌지 유형', weight: '무게(kg)',
            targetAngle: '목표 각도(°)', targetTime: '목표 시간(초)', voltage: '전압(V)',
            tempMin: '최저 온도(℃)', tempMax: '최고 온도(℃)', loadCondition: '추가 하중'
        };
        const brief = this.selectedReport?.brief || {};
        return Object.keys(brief)
            .filter((key: string) => !key.startsWith('_'))
            .map((key: string) => ({ key, label: labels[key] || key, value: brief[key] }));
    }

    public candidateRows(): any[] {
        return this.selectedReport?.candidates || [];
    }

    public selectedCandidate(): any {
        return this.selectedReport?.selectedCandidate || null;
    }

    public moduleLabel(module: any): string {
        if (!module) return '-';
        return module.model || module.name || module.id || '-';
    }

    public deviationRows(): any[] {
        return this.selectedReport?.deviations || this.selectedReport?.mcuComparison?.deviations || [];
    }

    public overallMatchValue(): any {
        const value = this.selectedReport?.overallMatch;
        if (value !== undefined && value !== null) return value;
        return this.selectedReport?.mcuComparison?.overallMatch || '-';
    }

    public mcuVerdict(): string {
        return this.selectedReport?.mcuComparison?.verdict || this.selectedReport?.verdict || '-';
    }

    public evidenceRows(): any[] {
        const report = this.selectedReport || {};
        const engine = report.engine || report.reproducibleInputs?.engine || {};
        const source = report.dataSource || {};
        return [
            { label: '생성 시각', value: report.generatedAt || report.date || '-' },
            { label: '검증 등급', value: report.validationGrade || '-' },
            { label: '사용 엔진', value: engine.engine_type || report.engine_type || '-' },
            { label: '엔진 버전', value: engine.engine_version || report.engine_version || '-' },
            { label: '입력 스키마', value: engine.input_schema_version || report.input_schema_version || '-' },
            { label: '데이터 출처', value: source.label || report.sourceLabel || report.mcuSource || '-' },
            { label: '신뢰 샘플', value: source.trustedSampleCount !== undefined ? `${source.trustedSampleCount}건` : `${report.trustedSampleCount || 0}건` },
        ];
    }

    public criteriaRows(): any[] {
        return this.selectedReport?.criteriaEvaluations || [];
    }

    public failedValidationRows(): any[] {
        return this.selectedReport?.failedValidationItems || [];
    }

    public hasCurrentComparisonData(): boolean {
        return this.hasRows(this.selectedReport?.currentSeries);
    }

    public hasSpeedComparisonData(): boolean {
        return this.hasRows(this.selectedReport?.speedSeries);
    }

    public chartMissingMessage(): string {
        if (this.isMcuComparisonReport()) {
            return '이전 방식으로 생성된 MCU 비교 리포트라 원본 시뮬레이션 Moment/Force 프로파일이 저장되어 있지 않습니다. 새로 생성한 MCU 비교 리포트부터 차트가 표시됩니다.';
        }
        return '차트를 그릴 시뮬레이션 프로파일 데이터가 없습니다.';
    }

    private renderChartsSoon() {
        setTimeout(() => this.renderCharts(), 50);
    }

    // MCU 시계열 비교 로드 (FN-0004)
    public async loadMcuTimeComparison() {
        if (!this.selectedReport?.id) return;
        this.isLoadingMcuTime = true;
        await this.service.render();
        const res = await wiz.call("mcu_time_comparison", { id: this.selectedReport.id });
        this.isLoadingMcuTime = false;
        if (res.code === 200) {
            this.mcuTimeData = res.data;
            await this.service.render();
            setTimeout(() => this.renderMcuTimeChart(), 50);
        } else {
            this.mcuTimeData = null;
            await this.service.render();
        }
    }

    public async switchMcuTimeTab(tab: string) {
        this.mcuTimeTab = tab;
        await this.service.render();
        setTimeout(() => this.renderMcuTimeChart(), 50);
    }

    private renderMcuTimeChart() {
        if (!this.mcuTimeData || !this.mcuTimeOverlayChart?.nativeElement) return;
        // 기존 차트 제거
        const existing = this.charts.findIndex((c: any) => c._mcuTime);
        if (existing >= 0) {
            this.charts[existing].destroy();
            this.charts.splice(existing, 1);
        }

        const keyMap: any = {
            'moment': { simKey: 'momentData', xcol: 'angle', ycol: 'moment', label: '모멘트 (Nm)' },
            'force': { simKey: 'forceData', xcol: 'stroke', ycol: 'force', label: '힘 (N)' },
            'speed': { simKey: 'speedData', xcol: 'time', ycol: 'speed', label: '속도 (°/s)' },
            'current': { simKey: 'currentData', xcol: 'time', ycol: 'current', label: '전류 (A)' },
        };
        const cfg = keyMap[this.mcuTimeTab] || keyMap['moment'];
        const simData = this.mcuTimeData.sim_series?.[cfg.simKey] || [];
        const mcuData = this.mcuTimeData.mcu_series?.[this.mcuTimeTab] || [];

        const labels = simData.map((r: any) => r[cfg.xcol]);
        const simValues = simData.map((r: any) => r[cfg.ycol]);
        const mcuValues = mcuData.map((r: any) => r.value ?? r[cfg.ycol] ?? 0);

        const chart: any = new Chart(this.mcuTimeOverlayChart.nativeElement, {
            type: 'line',
            data: {
                labels,
                datasets: [
                    { label: `Sim ${cfg.label}`, data: simValues, borderColor: '#38bdf8', fill: false, tension: 0.3, pointRadius: 0, borderWidth: 2 },
                    { label: `MCU ${cfg.label}`, data: mcuValues, borderColor: '#f97316', borderDash: [5, 3], fill: false, tension: 0.3, pointRadius: 0, borderWidth: 2 },
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { display: true, labels: { color: '#64748b', boxWidth: 10, font: { size: 10 } } } },
                scales: {
                    x: { ticks: { color: '#94a3b8', font: { size: 10 } }, grid: { color: 'rgba(148, 163, 184, 0.12)' } },
                    y: { ticks: { color: '#94a3b8', font: { size: 10 } }, grid: { color: 'rgba(148, 163, 184, 0.12)' } },
                }
            }
        });
        chart._mcuTime = true;
        this.charts.push(chart);
    }

    private destroyCharts() {
        for (const chart of this.charts) {
            chart.destroy();
        }
        this.charts = [];
    }

    private renderCharts() {
        if (!this.selectedReport) return;
        this.destroyCharts();

        const momentRows = this.selectedReport.momentData || this.selectedReport.moment_analysis || [];
        const forceRows = this.selectedReport.forceData || this.selectedReport.force_analysis || [];
        const currentRows = this.selectedReport.currentSeries || [];
        const speedRows = this.selectedReport.speedSeries || [];

        this.createChart(this.momentReportChart, 'line', momentRows, 'angle', 'moment', '#67e8f9', 'rgba(103, 232, 249, 0.18)');
        this.createChart(this.forceReportChart, 'line', forceRows, 'stroke', 'force', '#34d399', 'rgba(52, 211, 153, 0.18)');
        this.createComparisonChart(this.currentComparisonChart, currentRows, 'time', 'sim', 'mcu', 'Sim current', 'MCU current');
        this.createComparisonChart(this.speedComparisonChart, speedRows, 'time', 'sim', 'mcu', 'Sim speed', 'MCU speed');
    }

    private createComparisonChart(
        target: ElementRef<HTMLCanvasElement> | undefined,
        rows: any[],
        xKey: string,
        simKey: string,
        mcuKey: string,
        simLabel: string,
        mcuLabel: string
    ) {
        if (!target?.nativeElement || !rows?.length) return;

        const chart = new Chart(target.nativeElement, {
            type: 'line',
            data: {
                labels: rows.map((row: any) => row[xKey]),
                datasets: [
                    {
                        label: simLabel,
                        data: rows.map((row: any) => row[simKey]),
                        borderColor: '#38bdf8',
                        backgroundColor: 'rgba(56, 189, 248, 0.12)',
                        fill: false,
                        tension: 0.3,
                        pointRadius: 0,
                        borderWidth: 2,
                    },
                    {
                        label: mcuLabel,
                        data: rows.map((row: any) => row[mcuKey]),
                        borderColor: '#f97316',
                        backgroundColor: 'rgba(249, 115, 22, 0.12)',
                        fill: false,
                        tension: 0.3,
                        pointRadius: 0,
                        borderWidth: 2,
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: true, labels: { color: '#64748b', boxWidth: 10, font: { size: 10 } } }
                },
                scales: {
                    x: { ticks: { color: '#94a3b8', font: { size: 10 } }, grid: { color: 'rgba(148, 163, 184, 0.12)' } },
                    y: { ticks: { color: '#94a3b8', font: { size: 10 } }, grid: { color: 'rgba(148, 163, 184, 0.12)' } }
                }
            }
        });

        this.charts.push(chart);
    }

    private createChart(
        target: ElementRef<HTMLCanvasElement> | undefined,
        type: 'line' | 'bar',
        rows: any[],
        xKey: string,
        yKey: string,
        color: string,
        fillColor: string
    ) {
        if (!target?.nativeElement || !rows?.length) return;

        const chart = new Chart(target.nativeElement, {
            type,
            data: {
                labels: rows.map((row: any) => row[xKey]),
                datasets: [{
                    data: rows.map((row: any) => row[yKey]),
                    borderColor: color,
                    backgroundColor: fillColor,
                    fill: type === 'line',
                    tension: 0.3,
                    pointRadius: 0,
                    borderWidth: 2,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { display: false } },
                scales: {
                    x: {
                        ticks: { color: '#94a3b8', font: { size: 10 } },
                        grid: { color: 'rgba(148, 163, 184, 0.12)' }
                    },
                    y: {
                        ticks: { color: '#94a3b8', font: { size: 10 } },
                        grid: { color: 'rgba(148, 163, 184, 0.12)' }
                    }
                }
            }
        });

        this.charts.push(chart);
    }
}

export default PageReportsComponent;